// src/pages/Procurement/ProcurementKanban.jsx
import React from "react";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import { useProcurement } from "../../context/ProcurementContext";

const ProcurementCard = ({ order, index }) => (
  <Draggable draggableId={order.id.toString()} index={index}>
    {(provided) => (
      <div
        className="bg-white p-3 mb-3 rounded-md shadow"
        ref={provided.innerRef}
        {...provided.draggableProps}
        {...provided.dragHandleProps}
      >
        <h6 className="font-semibold text-gray-800">{order.poNumber}</h6>
        <p className="text-sm text-gray-600">{order.vendorName}</p>
        <p className="text-xs text-gray-500">Budget: ${order.budgetAllocated}</p>
      </div>
    )}
  </Draggable>
);

const ProcurementKanbanView = ({ data }) => {
  const { saveProcurement } = useProcurement();

  const groups = {
    Pending: data.filter((p) => p.status === "Pending"),
    Approved: data.filter((p) => p.status === "Approved"),
    Sent: data.filter((p) => p.status === "Sent"),
    Fulfilled: data.filter((p) => p.status === "Fulfilled"),
  };

  const onDragEnd = (result) => {
    const { draggableId, destination, source } = result;
    if (!destination) return;

    if (destination.droppableId !== source.droppableId) {
      saveProcurement({ id: draggableId, status: destination.droppableId });
    }
  };

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 p-2">
        {Object.entries(groups).map(([status, list]) => (
          <Droppable droppableId={status} key={status}>
            {(provided) => (
              <div
                className="bg-gray-50 p-4 rounded-lg min-h-[300px]"
                ref={provided.innerRef}
                {...provided.droppableProps}
              >
                <h6 className="font-medium text-gray-800 mb-3">
                  {status} ({list.length})
                </h6>

                {list.map((order, index) => (
                  <ProcurementCard key={order.id} order={order} index={index} />
                ))}

                {provided.placeholder}
              </div>
            )}
          </Droppable>
        ))}
      </div>
    </DragDropContext>
  );
};

export default ProcurementKanbanView;
